// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2ehHE","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1Yqix"};